
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import { acenteninSorumluluklari, alicininSurumluluklari, gondereninSorumluluklari, tasiyicininSorumluluklari } from '../../utils/jobList/mektupDoc';
import formatConverter from '../../helper/formatConverter';
import getCurrentDate from '../../helper/getCurrentDate';
import getCurrentTime from '../../helper/getCurrentTime';

const TasimaSenediShipmentPDF = ({data}) => {


    Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf",
        fontWeight: 300,
        fontStyle: "normal"
      });
      
      Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf",
        fontWeight: 400,
        fontStyle: "normal"
      });
      
      Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf",
        fontWeight: 500,
        fontStyle: "normal"
      });
      
      Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf",
        fontWeight: 700,
        fontStyle: "normal"
      });
      
      Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-black-webfont.ttf",
        fontWeight: 900,
        fontStyle: "normal"
      });

    const styles = StyleSheet.create({
        page: {
            fontFamily: "Roboto",
            padding: "25px",
        },

        wrapper: {
         width: "100%",
         height: "100%",
         display: "flex",
         flexDirection: "row",
         gap: "4px"
        },

        formSide: {
            width: "45%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: "4px"
        },
        
        formTop:{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "22px",
            border: "2px solid #000",
            borderRadius: "5px",
        },

        formTitle:{
            fontSize: "8px",
            fontWeight: "600",
        },

        formSectionItem: {
            display: "flex",
            flexDirection: "column",
            gap: "4px",
            padding: "3px 0",
            border: "2px solid #000",
            borderRadius: "5px"
        },

        formSectionItemTop:{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            lineHeight: 1.6,
            borderBottom: "1px solid #000",
        },

        formSectionItemTitle: {
            fontSize: "8px",
            fontWeight: "600",
        },

        formItem: {
            display: "flex",
            flexDirection: "row",
            fontSize: "8px",
            gap: "5px",
            padding: "0 10px",
        },

        formItemMarginBottom:{
            paddingBottom: "10px"
        },
        
        formItemKey: {
            fontWeight:700
        },

        formItemValueDot: {
            borderBottom: "1px dotted #000",
            width: "140px",
            textAlign: "center"
        },

        formItemDateTimeValue: {
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            textAlign: "center"
        },

        formItemDateValue: {
            display: "flex",
            flexDirection: "row",
            gap: "2px",
            textAlign: "center"
        },

        formItemTimeValue: {
            display: "flex",
            flexDirection: "row",
            textAlign: "center"

        },

        dateTimeBorderBottom:{
            width: "20px",
            borderBottom: "1px dotted #000",
            textAlign: "center"
        },

        dateTimeBorderBottomLg:{
            width: "30px",
            borderBottom: "1px dotted #000",
            textAlign: "center"
        },

        docSide: {
            width: "55%",
            height: "100%",
            border: "2px solid #000",
            padding: "5px 10px",
            borderRadius: "5px"
        },

        docListGrp: {
            marginBottom: "5px",
            display: "flex",
            flexDirection:"column",
            gap: "2px"
        },

        docTitle:{
            fontWeight: 500,
            fontSize: "8px"
        },

        listItem:{
            fontSize: "7px",
            lineHeight: "1.1"
        },

        descBottomItem:{
            fontSize: "7px",
            paddingBottom: "10px",
            fontWeight: 500,
        }
      });

    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
      
      
    return(
        <Document fileName="tasima-senedi" title={`Tasima-Senedi-${getCurrentDate()}-${getCurrentTime()}-${data?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber ? data?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber : ""}`}>
        <Page size="A4" style={styles.page} orientation="landscape">
            <View style={styles.wrapper}>
                <View style={styles.formSide}>
                    <View style={styles.formTop}>
                        <Text style={styles.formTitle}>TAŞIMA SENEDİ</Text>
                        </View>
                        <View style={styles.formSectionItem}>
                            <View style={styles.formSectionItemTop}>
                                <Text style={styles.formSectionItemTitle}>ACENTE/YUKVEREN TEMSİLCİSİ</Text>
                            </View>
                            <View style={styles.formItem}>
                                <Text style={styles.formItemKey}>Acente Firma Adı:</Text>
                                <Text style={styles.formItemValueDot}>{JSON.parse(storage.getItem("cShortName"))}</Text>
                            </View>
                            <View style={styles.formItem}>
                                <Text style={styles.formItemKey}>Acente Firma Telefonu:</Text>
                                <Text style={styles.formItemValueDot}>{JSON.parse(storage.getItem("cPhoneNumber"))}</Text>
                            </View>
                            <View style={styles.formItem}>
                                <Text style={styles.formItemKey}>Düzenleme Tarih ve Saati:</Text>
                                <Text style={styles.formItemValueDot}></Text>
                            </View>
                            <View style={styles.formItem}>
                                <Text style={styles.formItemKey}>Acente Yetkili İmzası:</Text>
                                <Text style={styles.formItemValueDot}></Text>
                            </View>
                        </View>

                    <View style={styles.formSectionItem}>
                        <View style={styles.formSectionItemTop}>
                            <Text style={styles.formSectionItemTitle}>GÖNDERİCİ (YÜK VEREN / YÜK SAHİBİ)</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Adı Soyadı/Ünvanı:</Text>
                            <Text style={data?.routePoints?.$values[0]?.companyName ? styles.formItemValue : styles.formItemValueDot}>{data?.routePoints?.$values[0]?.companyName}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>TC No / Vergi No - Vergi Dairesi:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>İlçe/İl:</Text>
                            <Text style={styles.formItemValueDot}>{data?.senderAdressTown}/{data?.senderAdressCity}</Text>
                        </View>
                        <View style={[styles.formItem, styles.formItemMarginBottom]}>
                            <Text style={styles.formItemKey}>Yükleme Adresi:</Text>
                            <Text style={styles.formItemValueDot}>{data?.routePoints?.$values[0]?.address}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Yükün İçeriği:</Text>
                            <Text style={styles.formItemValue}>{data?.loadType}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Yükün Miktarı:</Text>
                            <Text style={styles.formItemValue}>{formatConverter(data?.loadQuantity, 0)} {data?.loadUnit}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Taşıma Ücreti (KDV Hariç):</Text>
                            <Text style={styles.formItemValue}>{formatConverter(data?.freight, 0)} TL</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Ödeme Şekli:</Text>
                            <Text style={styles.formItemValue}>{data?.paymentType}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Yükleme Tarih ve Saati:</Text>
                            <View style={styles.formItemDateTimeValue}>
                                <View style={styles.formItemDateValue}>
                                    <Text style={styles.dateTimeBorderBottom}>{data?.waitinLoad?.planningLoadDate?.split(".")[0]}</Text>
                                    <Text>/</Text>
                                    <Text style={styles.dateTimeBorderBottom}>{data?.waitinLoad?.planningLoadDate?.split(".")[1]}</Text>
                                    <Text>/</Text>
                                    <Text style={styles.dateTimeBorderBottomLg}>{data?.waitinLoad?.planningLoadDate?.split(".")[2]}</Text>
                                </View>

                                <View style={styles.formItemTimeValue}>
                                    <Text style={styles.dateTimeBorderBottom}>{data?.waitinLoad?.planningLoadTime?.split(":")[0]}</Text>
                                    <Text style={styles.timeSeperator}>:</Text>
                                    <Text style={styles.dateTimeBorderBottom}>{data?.waitinLoad?.planningLoadTime?.split(":")[1]}</Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Teslim Eden-Adı Soyadı:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Teslim Eden-İmzası:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                    </View>

                    <View style={styles.formSectionItem}>
                        <View style={styles.formSectionItemTop}>
                            <Text style={styles.formSectionItemTitle}>TAŞIYICI</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Adı Soyadı:</Text>
                            <Text style={styles.formItemValue}>{data?.driverName}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>TC No:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Telefonu:</Text>
                            <Text style={styles.formItemValue}>{data?.driverPhoneNumber}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>İlçe/İl:</Text>
                            <Text style={styles.formItemValueDot}>{data?.receiverAdressTown}/{data?.receiverCity}</Text>
                        </View>
                        <View style={[styles.formItem, styles.formItemMarginBottom]}>
                            <Text style={styles.formItemKey}>Adresi:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Ruhsat Sahibi Adı Soyadı:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Arac Türü ve Plakaları:</Text>
                            <Text style={styles.formItemValue}>{data?.truckType}/{data?.trailerType}/{data?.waitinLoad?.aspiredLoads?.$values[0]?.truckPlateNumber}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Taşıyıcı-Adı Soyadı:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Taşıyıcı-İmzası:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                    </View>

                    <View style={styles.formSectionItem}>
                        <View style={styles.formSectionItemTop}>
                            <Text style={styles.formSectionItemTitle}>ALICI</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Adı Soyadı/Ünvanı:</Text>
                            <Text style={data?.routePoints?.$values[data?.routePoints?.$values?.length-1]?.companyName ? styles.formItemValue : styles.formItemValueDot}>{data?.routePoints?.$values[data?.routePoints?.$values?.length-1]?.companyName}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>TC No/Vergi No-Vergi Dairesi:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={[styles.formItem, styles.formItemMarginBottom]}>
                            <Text style={styles.formItemKey}>Boşaltma Adresi:</Text>
                            <Text style={data?.routePoints?.$values[data?.routePoints.$values?.length-1]?.address ? styles.formItemValue : styles.formItemValueDot}>{data?.routePoints?.$values[data?.routePoints?.$values?.length-1]?.address}</Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Boşaltıldığı Tarih ve Saati:</Text>
                            <View style={styles.formItemDateTimeValue}>
                                <View style={styles.formItemDateValue}>
                                    {/* <Text style={styles.dateTimeBorderBottom}>{data?.yukData?.planningUnloadDate?.split(".")[0]}</Text> */}
                                    <Text style={styles.dateTimeBorderBottom}></Text>
                                    <Text>/</Text>
                                    {/* <Text style={styles.dateTimeBorderBottom}>{data?.yukData?.planningUnloadDate?.split(".")[1]}</Text> */}
                                    <Text style={styles.dateTimeBorderBottom}></Text>
                                    <Text>/</Text>
                                    {/* <Text style={styles.dateTimeBorderBottomLg}>{data?.yukData?.planningUnloadDate?.split(".")[2]}</Text> */}
                                    <Text style={styles.dateTimeBorderBottomLg}></Text>
                                </View>

                                <View style={styles.formItemTimeValue}>
                                    {/* <Text style={styles.dateTimeBorderBottom}>{data?.yukData?.planningUnloadTime?.split(":")[0]}</Text> */}
                                    <Text style={styles.dateTimeBorderBottom}></Text>
                                    <Text style={styles.timeSeperator}>:</Text>
                                    {/* <Text style={styles.dateTimeBorderBottom}>{data?.yukData?.planningUnloadTime?.split(":")[1]}</Text> */}
                                    <Text style={styles.dateTimeBorderBottom}></Text>
                                </View>
                            </View>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Teslim Alan Adı Soyadı:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                        <View style={styles.formItem}>
                            <Text style={styles.formItemKey}>Teslim Alan İmzası:</Text>
                            <Text style={styles.formItemValueDot}></Text>
                        </View>
                    </View>
                </View>
                <View style={styles.docSide}>
                    <View style={styles.docListGrp}>
                        <Text style={styles.docTitle}>GÖNDERENİN SORUMLULUKLARI (YÜK VEREN / YÜK SAHİBİ):</Text>
                        {
                            gondereninSorumluluklari.map(item => (
                                <Text style={styles.listItem} key={item.id}>{item.id}. {item.text}</Text>
                            ))
                        }
                    </View>
                    <View style={styles.docListGrp}>
                        <Text style={styles.docTitle}>TAŞIYICININ SORUMLULUKLARI:</Text>
                        {
                            tasiyicininSorumluluklari.map(item => (
                                <Text style={styles.listItem} key={item.id}>{item.id}. {item.text}</Text>
                            ))
                        }
                        </View>
                    <View style={styles.docListGrp}>
                    <Text style={styles.docTitle}>ALICININ SORUMLULUKLARI:</Text>
                    {
                        alicininSurumluluklari.map(item => (
                            <Text style={styles.listItem} key={item.id}>{item.id}. {item.text}</Text>
                        ))
                    }
                    </View>
                    <View style={styles.docListGrp}>
                        <Text style={styles.docTitle}>ACENTENİN SORUMLULUKLARI:</Text>
                        {
                            acenteninSorumluluklari.map(item => (
                                <Text style={styles.listItem} key={item.id}>{item.id}. {item.text}</Text>
                            ))
                        }
                    </View>

                    <Text style={styles.docTitle}>KVKK - Aydınlatma ve Açık Rıza</Text>
                    <Text style={styles.descBottomItem}>İş bu belgenin imzalanmasıyla; taraflar, KVKK kapsamında, kişisel verilerinin karşı tarafça kayıt altına alınmasına, işlenmesine ve yük verme/alma amacıyla paylaşılmasına açık rıza vermiştir. Taraflar; bu kişisel verilerin ve belgelerin yük verme amacı dışında; başka amaçlarla kullanılmayacağını ve başkalarıyla paylaşılmayacağını kabul, beyan ve taahhüt eder.</Text>
                    <Text style={styles.descBottomItem}>Taraflar; bu hizmete ilişkin Kanuni tüm yükümlülüklere ve yukarıda belirtilen maddelere uyacağını peşinen kabul ve taahhüt eder.</Text>
                    <Text style={styles.descBottomItem}>İş bu Taşıma Senedi ; Acente, Gönderici, Taşıyıcı ve Alıcı için olmak üzere en az 3 (Üç) suret düzenlenmiştir.</Text>
                </View>
            </View>
        </Page>
        </Document>
    )
}


export default TasimaSenediShipmentPDF